export const scrollToSection = (targetSectionId: string) => {
  document.getElementById(targetSectionId)?.scrollIntoView({
    behavior: "smooth",
  });
};
